import { Component, OnInit } from '@angular/core';

interface Faq {
  label: string;
  items: FaqItem[];
}

interface FaqItem {
  label: string;
  content: string;
}

@Component({
  standalone: false,
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
})
export class FaqComponent  implements OnInit {
  
  faqs: Faq[] = [
    {
      label: 'Tracking',
      items: [
        {
          label: 'Who can be a tracker?',
          content: 'Some content needs to go here'
        },
        {
          label: 'Do I need account to follow score?',
          content: 'Some content needs to go here'
        },
        {
          label: 'How many people can track score for the same match?',
          content: 'Some content needs to go here'
        }
      ]
    },
    {
      label: 'System requirements & devices',
      items: [
        {
          label: 'Who can be a tracker',
          content: 'Some content needs to go here'
        }
      ]
    },
    {
      label: 'Tournaments',
      items: [
        {
          label: 'Who can be a tracker',
          content: 'Some content needs to go here'
        }
      ]
    },
    {
      label: 'Team matches',
      items: [
        {
          label: 'Who can be a tracker',
          content: 'Some content needs to go here'
        }
      ]
    }

  ]
  constructor() { }

  ngOnInit() { }

}
